// Storage half of `phiSearch.js`, with no React in it, so boot code (auth.js)
// can clear it on sign-out. See phiSearch.js for why search terms live here
// rather than in the URL.

export const PHI_SEARCH_PREFIX = 'parsina.search.';

export function readPhiSearchTerm(key) {
  try { return sessionStorage.getItem(PHI_SEARCH_PREFIX + key) || ''; } catch { return ''; }
}

export function writePhiSearchTerm(key, value) {
  try {
    if (value) sessionStorage.setItem(PHI_SEARCH_PREFIX + key, value);
    else sessionStorage.removeItem(PHI_SEARCH_PREFIX + key);
  } catch { /* storage refused (private mode): the term just is not restored */ }
}

/** Remove every stored search term — called on sign-out. */
export function clearPhiSearchTerms() {
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(PHI_SEARCH_PREFIX))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch { /* nothing to clear */ }
}
